import React, { FC } from "react";

import { StyledInfo } from "./styled";

type InfoFieldReadProps = {
    label: string;
    value: string;
    size?: string;
    readCustomSize?: boolean;
};

export const InfoFieldRead: FC<InfoFieldReadProps> = ({ label, value, readCustomSize = false, size }) => {
    return (
        <StyledInfo $size={size} $readCustomSize={readCustomSize}>
            <span>{label}</span>
            <span>{value}</span>
        </StyledInfo>
    );
};

export default InfoFieldRead;
